import { render, staticRenderFns } from "./OrderChangeStatusPaid.vue?vue&type=template&id=8b11fc2e&scoped=true"
import script from "./OrderChangeStatusPaid.vue?vue&type=script&lang=js"
export * from "./OrderChangeStatusPaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b11fc2e",
  null
  
)

export default component.exports